import clone from 'clone'

export default function toOldHotelFormat (tourHotel) {
  if (tourHotel.hotel) {
    const hotel = clone(tourHotel.hotel)
    hotel.availability = tourHotel.availability.slice(0)
    hotel.days = tourHotel.days.slice(0)
    return hotel
  }
  return tourHotel
}

